import { DAYS_TITLE } from '../../../consts';
/**
 * If the value is not a "Days" and value length smaller than "1",
 * concatenate "0" to value
 * @param value - string: number of (hours, minutes, seconds, days)
 * @param titleOfValue - string: title of the value
 * @returns - string
 */
export const convertTimeValues = (value, titleOfValue) => (titleOfValue === DAYS_TITLE ? value : `0${value}`.slice(-2));
